import axios from 'axios';
import { CacheOptions, setupCache } from 'axios-cache-interceptor';
import type { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

export type ApiClientConfig = {
  baseURL: string;
  cache: CacheOptions;
  headers: Record<string, string>;
};

export const createApiClient = ({ baseURL, headers, cache }: ApiClientConfig): AxiosInstance => {
  const axiosInstance = axios.create({
    baseURL,
    headers,
  });

  const cachedAxiosInstance = setupCache(axiosInstance, cache);

  return cachedAxiosInstance;
};

export const addResponseInterceptor = <T>(
  axiosInstance: AxiosInstance,
  onFulfilled: (value: AxiosResponse<T>) => AxiosResponse<T> | Promise<AxiosResponse<T>>,
  onRejected: (error: unknown) => void,
) => {
  return axiosInstance.interceptors.response.use(onFulfilled, onRejected);
};

export const addRequestInterceptor = <T>(
  axiosInstance: AxiosInstance,
  onFulfilled: (value: InternalAxiosRequestConfig<T>) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>,
  onRejected: (error: unknown) => unknown,
) => {
  return axiosInstance.interceptors.request.use(onFulfilled, onRejected);
};

export const removeRequestInterceptor = (axiosInstance: AxiosInstance, interceptorId: number) => {
  axiosInstance.interceptors.request.eject(interceptorId);
};

export const removeResponseInterceptor = (axiosInstance: AxiosInstance, interceptorId: number) => {
  axiosInstance.interceptors.response.eject(interceptorId);
};
